module.exports = __webpack_public_path__ + "media/images/navigation/photos-hover-2ab5316d116f117d5cbaa058a3f07e64.gif";